document.addEventListener('DOMContentLoaded', function () {
    const baseOptions = {
        type: 'loop',
        perMove: 1,
        arrows: true,
        speed: 500,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        pauseOnHover: false,
        pagination: true,
        accessibility: false,
        waitForTransition: false,
        flickMaxPages: 1,
        flickPower: 120,
        drag: true,
        snap: true,
    };

    document.querySelectorAll('.hero-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            autoplay: true,
            interval: 5000,
            perPage: 1,
        });

        splide.mount();
    });

    // Choose product splide
    document.querySelectorAll('.choose-products-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            perPage: 3,
            perMove: 1,
            focus: 0,
            clones: 6,
            trimSpace: false,
            gap: '1.25rem',
            arrows: false,
            pagination: true,
            breakpoints: {
                1200: {
                    gap: '0.75rem',
                },
                767: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    clones: 6,
                },
                500: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    clones: 6,
                    gap: '0.5rem',
                },
            },
        });

        splide.mount();
    });

    // Related product splide
    document.querySelectorAll('.related-products-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            perPage: 3,
            perMove: 1,
            focus: 0,
            clones: 6,
            trimSpace: false,
            gap: '1.25rem',
            arrows: false,
            pagination: true,
            breakpoints: {
                1200: {
                    gap: '0.75rem',
                },
                767: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    clones: 6,
                },
                500: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    clones: 6,
                    gap: '0.5rem',
                },
            },
        });

        splide.mount();
    });

    // Blog teaser splide
    document.querySelectorAll('.blog-teaser-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            perPage: 3,
            perMove: 1,
            focus: 0,
            clones: 6,
            trimSpace: false,
            gap: '1.25rem',
            arrows: false,
            pagination: false,
            breakpoints: {
                1200: {
                    gap: '0.75rem',
                },
                767: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    clones: 6,
                },
                500: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    clones: 6,
                    gap: '0.5rem',
                },
            },
        });

        splide.mount();
    });

    // Category teaser splide
    document.querySelectorAll('.category-teaser-splide').forEach((el) => {
        const splide = new Splide(el, {
            ...baseOptions,
            perPage: 4,
            perMove: 1,
            focus: 0,
            clones: 8,
            trimSpace: false,
            gap: '1.25rem',
            arrows: true,
            pagination: true,
            breakpoints: {
                1200: {
                    perPage: 3,
                    gap: '0.75rem',
                },
                767: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    clones: 8,
                    arrows: false,
                },
                500: {
                    perPage: 2,
                    perMove: 1,
                    focus: 0,
                    clones: 8,
                    gap: '0.5rem',
                    arrows: false,
                },
            },
        });

        splide.mount();
    });
});